module.exports = __webpack_public_path__ + "img/featured.7da552fc.png";